module.exports = "/assets/data/1e3bf72dc783fdd26e5d67f46011a419-GL11.data.json";